import React, { PureComponent } from 'react'
import { APP_URL } from '../utils/config.js'
import {
  getFabricById,
  setAdditionalFillingOptions,
  setCanProceedToNextStep,
  setCordFabricDirection,
  setFabricDirection,
  setIsConnected,
  setSelectedCordFabric,
  setSelectedFabric,
  setSelectedFilling,
} from '../actions/generalActions.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { BarLoader } from 'react-spinners'
import { displayToast, getEstimate, scrollTo, sendGtag } from '../utils/utils.js'
import { getAllFabrics } from '../actions/fabricsActions.js'
import StepTitle from './StepTitle/index.js'

class CushionFillingSelector extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      allFabrics: null,
    }
  }

  componentDidMount() {
    const { general, dispatch, params } = this.props
    const canProceed = !!general.filling
    this._getAllFabrics()
    dispatch(setCanProceedToNextStep(canProceed))
    scrollTo('site-header', 100)
    if (
      (params?.dimensions?.includes('join') || params?.dimensions?.includes('pinch')) &&
      params?.type?.id === '11786'
    ) {
      dispatch(setIsConnected(true))
    }
    if (!general.fabric && params?.fabric?.id) {
      getFabricById(params?.fabric?.id).then((fabric) => {
        if (fabric) {
          dispatch(setSelectedFabric(fabric))
          dispatch(setFabricDirection(params?.fabric?.direction))
        } else {
          dispatch(setSelectedFabric(null))
          dispatch(setFabricDirection(null))
        }
      })
    }
    if (!general.cordFabric && params?.style?.fabricId !== 'fabric') {
      getFabricById(params?.style?.fabricId).then((fabric) => {
        if (fabric) {
          dispatch(setSelectedCordFabric(fabric))
          dispatch(setCordFabricDirection(params?.style?.fabricDirection))
        } else {
          dispatch(setSelectedCordFabric(null))
          dispatch(setCordFabricDirection(null))
        }
      })
    }
    setTimeout(() => {
      this._getPrice()
    }, 200)
  }

  componentDidUpdate(prevProps) {
    const { params, dispatch, cushion, general, history, location } = this.props
    const { cushionFillings } = cushion
    const { filling, additionalFillingOptions, canProceedToNextStep } = general
    if (prevProps.cushion.cushionFillings !== cushionFillings) {
      if (params.filling !== 'filling' && parseInt(params.filling) && cushionFillings) {
        let selectedFilling = cushionFillings.find((type) => type.id === parseInt(params.filling))
        if (selectedFilling) {
          dispatch(setCanProceedToNextStep(true))
        } else {
          history.push(`/cd/${params.category}/type`)
          displayToast(
            'The URL you were trying to access is broken. Please reselect your options',
            'error',
          )
        }
      }
      let cushionFillingsCopy = cushionFillings.filter((filling) => [796, 862].includes(filling.id))

      if (cushionFillingsCopy.length === 0) {
        dispatch(setAdditionalFillingOptions({}))
      }

      if (location.pathname.includes('-726')) {
        let additionalFillingOption = cushionFillings.find((filling) => filling.id === 726)
        dispatch(setAdditionalFillingOptions({ 726: additionalFillingOption }))
      }
      if (location.pathname.includes('-874')) {
        let additionalFillingOption = cushionFillings.find((filling) => filling.id === 874)
        dispatch(setAdditionalFillingOptions({ 874: additionalFillingOption }))
      }
      if (location.pathname.includes('726-874')) {
        let additionalFillingOption1 = cushionFillings.find((filling) => filling.id === 726)
        let additionalFillingOption2 = cushionFillings.find((filling) => filling.id === 874)
        dispatch(
          setAdditionalFillingOptions({
            ...additionalFillingOptions,
            726: additionalFillingOption1,
            874: additionalFillingOption2,
          }),
        )
      }
    }
    if (prevProps.general.filling !== filling) {
      if (filling?.id !== 722 && filling?.id !== 723) {
        dispatch(setAdditionalFillingOptions({ ...additionalFillingOptions, 726: null }))
      }
    }
    if (prevProps.general.canProceedToNextStep !== canProceedToNextStep) {
      if (!general.filling && params.filling === 'filling') {
        dispatch(setCanProceedToNextStep(false))
      }
    }
  }

  _getAllFabrics = () => {
    getAllFabrics().then((allFabrics) => {
      this.setState({
        allFabrics: allFabrics,
      })
    })
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    setTimeout(() => {
      getEstimate(dispatch, general, params)()
    }, 100)
  }

  _selectCushionFilling = (filling) => () => {
    const { allFabrics } = this.state
    const { dispatch, general, params, fabrics } = this.props
    const {
      additionalFillingOptions,
      filling: selectedFilling,
      beenThrough,
      cordFabric,
      fabric,
      fabricDirection,
      enableScrollTo,
    } = general
    const isLoosePolyesterSelected = !!Object.values(additionalFillingOptions)
      .filter(Boolean)
      .find((filling) => filling.id === 796)

    if (filling?.id === selectedFilling?.id) {
      return
    }

    if (isLoosePolyesterSelected) {
      return displayToast('Uncheck the Loose Polyester additional fabric selection first.', 'info')
    }

    // this is here to provide fabrics and directions if there is no fabric in redux state
    if (!beenThrough.fabrics && !beenThrough.style) {
      if (params.style) {
        if (!cordFabric) {
          dispatch(setCordFabricDirection(params.style.fabricDirection))
          let selectedFabric = fabrics.fabrics.find(
            (fabric) => fabric.id.toString() === params.style.fabricId,
          )
          if (!selectedFabric) {
            if (allFabrics) {
              selectedFabric = allFabrics.find(
                (fabric) => fabric.id.toString() === params.fabric.id,
              )
              dispatch(setSelectedCordFabric(selectedFabric, !!selectedFabric))
            }
          }
          if (selectedFabric) {
            dispatch(setSelectedCordFabric(selectedFabric, !!selectedFabric))
          }
        }
      }
      if (params.fabric) {
        if (!fabric) {
          dispatch(setFabricDirection(fabricDirection))
          let selectedFabric = fabrics.fabrics.find(
            (fabric) => fabric.id.toString() === params.fabric.id,
          )

          if (!selectedFabric) {
            if (allFabrics) {
              selectedFabric = allFabrics.find(
                (fabric) => fabric.id.toString() === params.fabric.id,
              )
              dispatch(setSelectedFabric(selectedFabric))
            }
          }

          if (selectedFabric) {
            dispatch(setSelectedFabric(selectedFabric))
          }
        }
      }
    }

    if (filling.id === 726) {
      this._selectCushionAdditionalFillingOption(filling)()
    } else {
      sendGtag('select_type_filling', filling?.name)
      dispatch(setSelectedFilling(filling))
    }

    if (
      (params?.type?.id === '12090' ||
        params?.type?.id === '11786' ||
        params?.type?.id === '11864') &&
      (filling.id === 722 || filling.id === 723 || filling.id === 724)
    ) {
      setTimeout(() => {
        scrollTo('cushion-filling-additional-back-options')
      }, 100)
    }

    if (
      [796, 722, 723].includes(filling.id) &&
      (params?.type?.id === '11786' ||
        params?.type?.id === '11864' ||
        params?.type?.id === '13101') &&
      (filling.id === 722 || filling.id === 723)
    ) {
      if (enableScrollTo === true) {
        if (params?.type?.id === '13101') {
          setTimeout(() => {
            scrollTo('scroll-here')
          }, 100)
        } else {
          setTimeout(() => {
            scrollTo('cushion-filling-additional-back-options')
          }, 100)
        }
      }
    }
    setTimeout(() => {
      this._getPrice()
    }, 500)
  }

  _selectCushionAdditionalFillingOption = (additionalFilling) => () => {
    const { dispatch, general } = this.props
    const { additionalFillingOptions } = general
    let newAdditionalFillings = { ...additionalFillingOptions }

    if (additionalFilling) {
      if (newAdditionalFillings[additionalFilling.id]) {
        newAdditionalFillings[additionalFilling.id] = null
        if (additionalFilling.id === 796) {
          newAdditionalFillings[862] = null
        }
      } else {
        newAdditionalFillings[additionalFilling.id] = additionalFilling
      }
    }

    sendGtag('select_type_filling', `${additionalFilling?.name}_Additional Filling Value ${newAdditionalFillings[additionalFilling?.id] ? 1 : 0}`)
    dispatch(setAdditionalFillingOptions(newAdditionalFillings))
    if (additionalFilling.id === 726) {
      dispatch(setCanProceedToNextStep(true))
    }
    setTimeout(() => {
      this._getPrice()
    }, 200)
  }

  _getFillingImages = (param) => {
    try {
      return require(`../../assets/filling/${param}.webp`).default
    } catch (error) {
      console.error('Failed to load image:', error) // eslint-disable-line
      return ''
    }
  }

  _renderCushionFillings = () => {
    const { allFabrics } = this.state
    const { general, cushion, layout } = this.props
    const { currentFlow } = layout
    const { filling, fabric, cordFabric, additionalFillingOptions, type } = general
    const { cushionFillings } = cushion

    let cushionFillingsCopy = cushionFillings === null ? null : [...cushionFillings]

    let allFabricsCondition = allFabrics === null && !fabric && !cordFabric

    if (cushionFillingsCopy === null || allFabricsCondition) {
      return <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
    }

    if (currentFlow === 'filling-only') {
      cushionFillingsCopy = cushionFillingsCopy.filter(
        (filling) => ![725, 873].includes(filling.id),
      )
    }

    // don't display the filling with id 726
    if (cushionFillingsCopy.find((filling) => filling.id === 726)) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling.id !== 726)
    }

    // display the filling with id 726 if the filling id is 722 and 723
    if (filling?.id === 722 || filling?.id === 723 || filling?.id === 726) {
      cushionFillingsCopy.push(cushionFillings.find((filling) => filling.id === 726))
    }

    if (type?.id === 11786 || type?.id === 11864 || type?.id === 12090 || type?.id === 11568) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling.id !== 874)
    }

    cushionFillingsCopy = cushionFillingsCopy.filter((filling) => ![796, 862].includes(filling.id))
    return cushionFillingsCopy.map((cushion) => {
      let additionalOption = cushionFillings.find((filling) => filling.id === 726)
      if (additionalOption) {
        return (
          <div
            key={cushion?.id}
            className={`cushion-filling-selector-card${currentFlow === 'pillow' ? '-horizontal' : ''} ${filling?.id === cushion?.id || additionalFillingOptions[additionalOption?.id]?.id === cushion?.id ? 'active' : ''} filling-${cushion?.slug}`}
            onClick={this._selectCushionFilling(cushion)}
          >
            {cushion?.id === 726 ? <div className="scroll-here"></div> : null}
            <div
              id={`cushion-filling-selector-card-${cushion?.slug}`}
              className={`cushion-filling-selector-card-checkbox checkbox-${cushion?.slug}`}
            >
              {filling?.id === cushion?.id ||
              additionalFillingOptions[additionalOption.id]?.id === cushion?.id ? (
                <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
              ) : null}
            </div>
            <div
              id={`cushion-filling-selector-card-image-${cushion?.slug}`}
              className={'cushion-filling-selector-card-image-container'}
            >
              <div
                className={`cushion-filling-selector-card-gradient ${filling?.id === cushion?.id || additionalFillingOptions[additionalOption?.id]?.id === cushion?.id ? 'cushion-filling-selector-card-gradient-active' : ''}`}
              />
              <div className="filling-image-wrapper">
                <img className={cushion?.slug} src={this._getFillingImages(cushion.slug)} />
              </div>
            </div>
            <div className={'cushion-filling-selector-card-text-container'}>
              <div className="card-title">{cushion.name}</div>
              <p>{cushion.description}</p>
            </div>
          </div>
        )
      } else {
        return (
          <div
            key={cushion?.id}
            className={`cushion-filling-selector-card ${filling?.id === cushion?.id ? 'active' : ''} filling-${cushion?.slug}`}
            onClick={this._selectCushionFilling(cushion)}
          >
            {cushion?.id === 726 ? <div className="scroll-here"></div> : null}
            <div
              id={`cushion-filling-selector-card-${cushion?.slug}`}
              className={`cushion-filling-selector-card-checkbox checkbox-${cushion?.slug}`}
            >
              {filling?.id === cushion?.id ? (
                <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
              ) : null}
            </div>
            <div
              id={`cushion-filling-selector-card-image-${cushion?.slug}`}
              className={'cushion-filling-selector-card-image-container'}
            >
              <div
                className={`cushion-filling-selector-card-gradient ${filling?.id === cushion?.id ? 'cushion-filling-selector-card-gradient-active' : ''}`}
              />
              <img className={cushion?.slug} src={this._getFillingImages(cushion.slug)} />
            </div>
            <div className={'cushion-filling-selector-card-text-container'}>
              <div className="card-title">{cushion.name}</div>
              <p>{cushion.description}</p>
            </div>
          </div>
        )
      }
    })
  }

  _renderAdditionalBackOptions = () => {
    const { general, cushion, layout /*params*/ } = this.props
    const { currentFlow } = layout
    const { additionalFillingOptions, filling, type } = general
    const { cushionFillings } = cushion
    let cushionFillingsCopy = cushionFillings === null ? null : [...cushionFillings]

    if (cushionFillingsCopy === null) {
      return null
    }

    if (additionalFillingOptions[796]) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => [796, 862].includes(filling.id))
    } else {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => [796].includes(filling.id))
    }

    if ((filling?.id === 722 || filling?.id === 723 || filling?.id === 724) && type?.id !== 11658) {
      cushionFillingsCopy.push(cushionFillings.find((filling) => filling.id === 874))
    }

    if (filling?.id === 725) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling.id === 726)
    }

    if (type?.id === 11568) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling?.id === 796)
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling.id === 726)
    }

    if (type?.id === 13101) {
      cushionFillingsCopy = cushionFillingsCopy.filter((filling) => filling.id !== 874)
    }

    return (
      <div
        className={`cushion-filling-selector-grid cushion-filling-additional-back-options ${currentFlow === 'pillow' ? 'pillow-filling-grid' : ''}`}
      >
        {cushionFillingsCopy.filter(Boolean).map((cushion) => {
          let additionalOption = cushionFillings.find((filling) => filling.id === cushion?.id)
          return (
            <div
              id={`cushion-filling-selector-card-${cushion?.slug}-1`}
              key={cushion?.id}
              onClick={this._selectCushionAdditionalFillingOption(cushion)}
              className={`cushion-filling-selector-card${currentFlow === 'pillow' ? '-horizontal' : ''} ${additionalFillingOptions[additionalOption?.id]?.id === cushion?.id ? 'active' : ''}`}
            >
              <div className={'cushion-filling-selector-card-checkbox'}>
                {additionalFillingOptions[additionalOption.id]?.id === cushion?.id && (
                  <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
                )}
              </div>
              <div
                className={'cushion-filling-selector-card-image-container'}
              >
                <div
                  className={`cushion-filling-selector-card-gradient ${additionalFillingOptions[additionalOption?.id]?.id === cushion.id ? 'cushion-filling-selector-card-gradient-active' : ''}`}
                />
                <div className="filling-image-wrapper additional-option">
                  <img className={cushion?.slug} src={this._getFillingImages(cushion.slug)} />
                </div>
              </div>
              <div className={'cushion-filling-selector-card-text-container'}>
                <div className="card-title">{cushion?.name}</div>
                <p>{cushion?.description}</p>
              </div>
              <div className={'cushion-filling-additional-back-option-label-container'}>
                <p>Additional Back Options</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  _renderAdditionalFillingOption = () => {
    const { general, cushion, layout } = this.props
    const { cushionFillings } = cushion
    const { currentFlow } = layout
    const { filling, additionalFillingOptions } = general

    if (filling?.id === 722 || filling?.id === 723) {
      let additionalOption = cushionFillings?.find((filling) => filling.id === 726)
      if (!additionalOption) {
        return null
      }
      return (
        <div
          id={`cushion-filling-selector-card-${additionalOption?.slug}-2`}
          onClick={this._selectCushionAdditionalFillingOption(additionalOption)}
          className={`cushion-filling-selector-card${currentFlow === 'pillow' ? '-horizontal' : ''} ${additionalFillingOptions[additionalOption.id]?.id === additionalOption?.id ? 'active' : ''}`}
        >
          <div className={'cushion-filling-selector-card-checkbox'}>
            {additionalFillingOptions[additionalOption.id]?.id === additionalOption.id && (
              <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
            )}
          </div>
          <div className={'cushion-filling-selector-card-image-container'}>
            <div
              className={`cushion-filling-selector-card-gradient ${additionalFillingOptions[additionalOption.id]?.id === additionalOption?.id ? 'cushion-filling-selector-card-gradient-active' : ''}`}
            />
            <div className='filling-image-wrapper'>
              <img
                src={
                  // `${APP_URL}/wp-content/uploads/2021/11/filling-${additionalOption?.slug}.png`
                  this._getFillingImages(additionalOption.slug)
                }
              />
            </div>
          </div>
          <div className={'cushion-filling-selector-card-text-container'}>
            <div className="card-title">{additionalOption?.name}</div>
            <p>{additionalOption?.description}</p>
          </div>
        </div>
      )
    }
    return null
  }

  handleViewFillingOpen = () => {
    sendGtag('view_filling_type_filling')
  }

  handleViewFillingAuxOpen = (event) => {
    if (event.button === 1) {
      sendGtag('view_filling_type_filling')
    }
  }

  render() {
    const { layout, general, currentLocationIndex } = this.props
    const { currentFlow } = layout
    const name = general?.type?.name

    return (
      <>
        <StepTitle
          name={name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
        />
        <p className={'cushion-designer-footer-text'}>
          Cushion Pros® is responsible for creating a finished product within a tolerance of
          one-half of an inch (1/2&ldquo;) of the dimensions provided by the customer.
        </p>
        <div className={'cushion-filling-selector'}>
          <a
            className={'cd-internal-link'}
            target="_blank"
            href={`${APP_URL}/filling-types/`}
            onClick={this.handleViewFillingOpen}
            onAuxClick={this.handleViewFillingAuxOpen}
          >
            View Filling Types
          </a>
          <div
            className={`cushion-filling-selector-grid ${currentFlow === 'pillow' ? 'pillow-filling-grid' : ''}`}
          >
            {this._renderCushionFillings()}
          </div>
          {this._renderAdditionalBackOptions()}
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  layout: state.layout,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionFillingSelector))
